import { Form } from "components/Forms";
import { RichText } from "components/RichTextWidget";
import { buildWidgetInstanceId } from "features/widgets";
import { WIDGETS_REGISTRY } from "features/widgets/widgets.config";
import { useRouter } from "next/router";
import {
  Action,
  Container,
  Heading1,
  Icon,
  ModalWrapper,
  PageLink,
  Paragraph,
} from "shared/components";
import { useToggle } from "shared/hooks";

import styles from "./Hero063.module.scss";

export const Hero063 = ({ payload }) => {
  const headline = payload?.headline ?? "";
  const subtitle = payload?.subtitle ?? "";
  const description = payload?.description ?? "";
  const buttonText = payload?.request?.buttonText ?? "";
  const form = payload?.request?.form ?? {};
  const type = payload?.request?.type ?? "form";
  const link = payload?.request?.link ?? "";

  const instanceId = buildWidgetInstanceId(
    "063",
    payload.id,
    WIDGETS_REGISTRY.HERO
  );

  const { query } = useRouter();

  const { opened, onOpen, onClose } = useToggle();

  return (
    <div className={styles.wrapper}>
      <Container>
        <div className={styles.block}>
          <div className={styles.top}>
            <Heading1 className={styles.headline} color="dark">
              {headline}
            </Heading1>
            {type === "form" ? (
              <Action onClick={onOpen} className={styles.play}>
                <span className={styles.arrow}>
                  <Icon className={styles.icon} name="arrow_right" />
                </span>
                <Paragraph color="brand" appearance="bigger">
                  {buttonText}
                </Paragraph>
              </Action>
            ) : (
              <PageLink className={styles.play} link={link}>
                <span className={styles.arrow}>
                  <Icon className={styles.icon} name="arrow_right" />
                </span>
                <Paragraph color="brand" appearance="bigger">
                  {buttonText}
                </Paragraph>
              </PageLink>
            )}

            {opened && (
              <ModalWrapper onCloseModal={onClose}>
                <Form
                  item={form}
                  metaData={{ page: query.slug }}
                  instanceId={instanceId}
                  onReset={onClose}
                />
              </ModalWrapper>
            )}
          </div>
          <div className={styles.bottom}>
            <div className={styles.text}>
              <Paragraph color="brand" className={styles.subtitle}>
                {subtitle}
              </Paragraph>
            </div>
            <RichText
              value={description}
              color="dark"
              className={styles.description}
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Hero063;
